class Carousel {
  constructor(container, items, controlsContainer, controls) {
    this.carouselContainer = container;
    this.carouselControls = controls;
    this.galleryControlsContainer = controlsContainer
    this.carouselArray = [...items];
    this.autoPlayTimeout = null
    this.timeout = null
  }

  // Update css classes for gallery
  updateGallery() {
    this.carouselArray.forEach(el => {
      el.classList.remove('gallery-item-1');
      el.classList.remove('gallery-item-2');
      el.classList.remove('gallery-item-3');
      el.classList.remove('gallery-item-4');
      el.classList.remove('gallery-item-5');
    });

    this.carouselArray.slice(0, 5).forEach((el, i) => {
      el.classList.add(`gallery-item-${i+1}`);
    });
  }

  enableAutoPlay(timeout) {
    this.autoPlayTimeout = timeout
    this.autoplay()
  }

  autoplay() {
    if (this.autoPlayTimeout) {
      this.timeout = setTimeout(() => {
        this.setCurrentState('gallery-controls-next')
      }, this.autoPlayTimeout)
    }
  }

  // Update the current order of the carouselArray and gallery
  setCurrentState(direction) {
    if (this.timeout) {
      clearTimeout(this.timeout)

      if (this.autoPlayTimeout) {
        this.autoplay()
      }
    }

    if (direction.className == 'gallery-controls-previous') {
      this.carouselArray.unshift(this.carouselArray.pop());
    } else {
      this.carouselArray.push(this.carouselArray.shift());
    }

    this.updateGallery();
  }

  // Construct the carousel navigation
  // setNav() {
    // galleryContainer.appendChild(document.createElement('ul')).className = 'gallery-nav';

    // this.carouselArray.forEach(item => {
    //   const nav = galleryContainer.lastElementChild;
    //   nav.appendChild(document.createElement('li'));
    // });
  // }s

  // Construct the carousel controls
  setControls() {
    this.carouselControls.forEach(control => {
      const { action, label } = typeof control === 'string' ? { action: control, label: control } : control
      this.galleryControlsContainer.appendChild(document.createElement('button')).className = `gallery-controls-${action}`;

      this.carouselContainer.querySelector(`.gallery-controls-${action}`).innerText = label;
    });
  }

  // Add a click event listener to trigger setCurrentState method to rearrange carousel
  useControls() {
    const triggers = [...this.galleryControlsContainer.childNodes];

    triggers.forEach(control => {
      control.addEventListener('click', e => {
        e.preventDefault();

        if (control.className == 'gallery-controls-add') {
          const newItem = document.createElement('img');
          const latestItem = this.carouselArray.length;
          const latestIndex = this.carouselArray.findIndex(item => item.getAttribute('data-index') == this.carouselArray.length)+1;

          // Assign the necessary properties for new gallery item
          Object.assign(newItem,{
            className: 'gallery-item',
            src: `http://fakeimg.pl/300/?text=${this.carouselArray.length+1}`
          });
          newItem.setAttribute('data-index', this.carouselArray.length+1);

          // Then add it to the carouselArray and update the gallery
          this.carouselArray.splice(latestIndex, 0, newItem);
          this.carouselContainer.querySelector(`[data-index="${latestItem}"]`).after(newItem);
          this.updateGallery();

        } else {
          this.setCurrentState(control);
        }

      });
    });
  }
}

export default Carousel
